import {UserDetailsVM} from '@generated/interfaces';

export const useIsIntegratedUser = (
  isFeatureOn: boolean,
  user: UserDetailsVM
): boolean =>
  isFeatureOn &&
  (!user?.isAcademiesIntegratedExperienceDisabled ||
    !user?.isContentMarketplaceIntegratedExperienceDisabled);
